// extracted by mini-css-extract-plugin
module.exports = {"OurPartners":"OurPartners_OurPartners__2aWpQ"};